export const endpoints = {
  findAll: '/patrimonies/:userId',
  findPaymentMethod: '/patrimonies/:userId/paymentMethod',
}
